export class FeaturesList {
    public ViewAudit: boolean = false;
    public SaveAudit: boolean  = false;
    public EditAudit: boolean  = false;
    public EditLocations: boolean = false;
    public EditUsers: boolean = false;
    public ScheduleAudit: boolean = false;
    public DeleteScheduledAudit: boolean = false;
    public CompleteAction: boolean = false;
    public EditAction: boolean = false;
    public ViewAction: boolean = false;
    public GroupManagement: boolean = false;
    public ViewCampaignResults: boolean = false;
    public EditCampaigns: boolean = false;
    public Reporting: boolean = false;

    public SimpleSaveAudit: boolean = false;
    public SimpleViewAudit: boolean = false;
    public SimpleCompleteAction: boolean = false;
    public SimpleViewAction: boolean = false;
    public SimpleAdmin: boolean = false;

    public HasFeatures: boolean = false;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
